
// Import vendor modules.
import Alpine from "alpinejs";

// Import app modules.
import "./global/**/*.js";
import "../views/**/*.js";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

window.Alpine = Alpine;

Alpine.start();
